/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type AppUsagePeriod = typeof AppUsagePeriod[keyof typeof AppUsagePeriod];


export const AppUsagePeriod = {
  Today: 'Today',
  Last7Days: 'Last7Days',
} as const;
